import { render } from "./Slide1.vue?vue&type=template&id=f1ace4a8&scoped=true"
import script from "./Slide1.vue?vue&type=script&lang=js"
export * from "./Slide1.vue?vue&type=script&lang=js"

import "./Slide1.vue?vue&type=style&index=0&id=f1ace4a8&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ace4a8"]])

export default __exports__